module.exports = __webpack_public_path__ + "img/resized-cover4.61de4830.png";